import React,{useEffect} from "react";
import Navbar from "./Navbar";
import { FaArrowRight } from "react-icons/fa";
import WOW from "wowjs";

const Header = () => {
	useEffect(() => {
		new WOW.WOW({
			live: false,
		}).init();
	});
	return (
		<header>
			<Navbar />
			<div id="home">
				<div className="center wow animate__animated animate__fadeIn" style={{ marginTop: "8rem" }} data-wow-duration="2s" data-wow-delay=".4s">
					<span className="colored-orange">Hi, my name is</span>
					<div className="header">
						<h2>ibrahim abdulsalam</h2>
					</div>
					<h2 className="colored-grey">a web developer.</h2>
					<p>I am a web developer specialized in building (and designing.Though occasionnaly work with ui/ux designer) websites.I like to craft solid and scalable frontend products with great user experiences</p>
					<a href="#projects">
						<button className="btn">
							view projects <FaArrowRight />
						</button>
					</a>
				</div>
			</div>
		</header>
	);
};

export default Header;
